import { m } from 'motion/react';
import type React from 'react';

export function AnimateMessage({ children }: { children: React.ReactNode }) {
  return (
    <m.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.15 }}>
      {children}
    </m.div>
  );
}
